'use strict';

require("core-js/modules/es6.regexp.replace");

var xtend = require('xtend');

var entities = require('stringify-entities');

module.exports = serializeComment; // See: <https://html.spec.whatwg.org/multipage/syntax.html#comments>

var breakout = /^>|^->|<!--|-->|--!>|<!-$/g;
var subset = ['<', '>'];
var bogusSubset = ['>'];

function serializeComment(ctx, node) {
  var value = node.value;

  if (ctx.bogusComments) {
    return '<?' + entities(value, xtend(ctx.entities, {
      subset: bogusSubset
    })) + '>';
  }

  return '<!--' + value.replace(breakout, encode) + '-->';

  function encode($0) {
    return entities($0, xtend(ctx.entities, {
      subset: subset
    }));
  }
}